import { ArrowsPointingOutIcon } from '@heroicons/react/20/solid';
import { OtsDialog, type OtsDialogProps } from '../components/OtsDialog';
import { OtsActionButton } from '../components/OtsButton';
import { ComplianceView, type ComplianceViewProps } from './ComplianceView';

export type ComplianceDialogProps = ComplianceViewProps &
  Pick<OtsDialogProps, 'open' | 'onClose' | 'brand' | 'colorScheme'>;
/** The same workspace inside the foundational modal shell. */
export const ComplianceDialog = ({
  open,
  onClose,
  brand,
  colorScheme,
  ...view
}: ComplianceDialogProps) => (
  <OtsDialog
    open={open}
    onClose={onClose}
    title={view.title ?? 'Compliance'}
    description={view.subjectLabel}
    actions={
      <>
        {view.onOpenFullPage && (
          <OtsActionButton
            size="compact"
            icon={<ArrowsPointingOutIcon />}
            onClick={view.onOpenFullPage}
          >
            Open full page
          </OtsActionButton>
        )}
        {view.onRefresh && (
          <OtsActionButton
            size="compact"
            disabled={view.refreshing || view.loading}
            onClick={view.onRefresh}
          >
            {view.refreshing ? 'Refreshing…' : 'Refresh'}
          </OtsActionButton>
        )}
      </>
    }
    brand={brand}
    colorScheme={colorScheme}
    compact={view.compact}
    divided
    bodyClassName="!p-0"
  >
    <ComplianceView {...view} showHeading={false} />
  </OtsDialog>
);
